import {
  GetAgencyByIdResponse,
  GetAgencyInvoicingByIdResponse,
  GetAgencyInvoiceSettingByIdResponse,
  GetAgencyBankByIdResponse,
  GetAgencyMarginByIdResponse,
  GetAgencyTimesheetValueByIdResponse,
  GetAgencyTimesheetValueByIdParams,
  GetAgencyAssignmentByIdParams,
  GetAgencyAssignmentByIdResponse,
  CreateAgencyBranchParams,
  CreateAgencyBranchResponse,
  UpdateAgencyBranchParams,
  UpdateAgencyBranchResponse,
  CreateAgencyContactParams,
  CreateAgencyContactResponse,
  UpdateAgencyContactParams,
  UpdateAgencyContactResponse,
  UpdateAgencyByIdParams,
  UpdateAgencyByIdResponse,
  UpdateAgencyInvoicingByIdParams,
  UpdateAgencyInvoicingByIdResponse,
  UpdateAgencyInvoiceSettingByIdParams,
  UpdateAgencyInvoiceSettingByIdResponse,
  UpdateAgencyMarginByIdParams,
  UpdateAgencyMarginByIdResponse,
  UpdateAgencyBankByIdParams,
  UpdateAgencyBankByIdResponse,
  CreateAgencyTimesheetValueByIdParams,
  CreateAgencyTimesheetValueByIdResponse,
  CreateAgencyPayload,
  CreateAgencyParams,
} from '@nxsys/types/api/agency';
import axios from '../axios';
import { endPoints } from '../endpoints';
import { CreateAgencyResponse, GetInvoiceListParams } from '@nxsys/types/api';
import { InvoiceStatus } from '@nxsys/constants/AppEnums';

export const getAgencyByIdApi = async (
  id: string,
): Promise<GetAgencyByIdResponse> => {
  const response = await axios.get(`${endPoints.agency.main}/${id}`);
  return response.data;
};

export const getAgencyInvoicingByIdApi = async (
  id: string,
): Promise<GetAgencyInvoicingByIdResponse> => {
  const response = await axios.get(`${endPoints.agency.main}/invoicing/${id}`);
  return response.data;
};

export const updateAgencyInvoicingByIdApi = async (
  id: string,
  params: UpdateAgencyInvoicingByIdParams,
): Promise<UpdateAgencyInvoicingByIdResponse> => {
  const response = await axios.post(
    `${endPoints.agency.main}/invoicing/${id}`,
    params,
  );
  return response.data;
};

export const getAgencyInvoiceSettingByIdApi = async (
  id: string,
): Promise<GetAgencyInvoiceSettingByIdResponse> => {
  const response = await axios.get(
    `${endPoints.agency.main}/invoice-settings/${id}`,
  );
  return response.data;
};

export const updateAgencyInvoiceSettingByIdApi = async (
  id: string,
  params: UpdateAgencyInvoiceSettingByIdParams,
): Promise<UpdateAgencyInvoiceSettingByIdResponse> => {
  const response = await axios.post(
    `${endPoints.agency.main}/invoice-settings/${id}`,
    params,
  );
  return response.data;
};

export const getAgencyBankByIdApi = async (
  id: string,
): Promise<GetAgencyBankByIdResponse> => {
  const response = await axios.get(`${endPoints.agency.main}/bank/${id}`);
  return response.data;
};

export const getAgencyMarginByIdApi = async (
  id: string,
): Promise<GetAgencyMarginByIdResponse> => {
  const response = await axios.get(`${endPoints.agency.main}/margin/${id}`);
  return response.data;
};

export const getAgencyTimesheetValueByIdApi = async (
  id: string,
  params: GetAgencyTimesheetValueByIdParams,
): Promise<GetAgencyTimesheetValueByIdResponse> => {
  const response = await axios.get(`${endPoints.agency.timesheetValue}/${id}`, {
    params,
  });
  return response.data;
};

export const createAgencyTimesheetValueByIdApi = async (
  id: string,
  params: CreateAgencyTimesheetValueByIdParams,
): Promise<CreateAgencyTimesheetValueByIdResponse> => {
  const response = await axios.post(
    `${endPoints.agency.timesheetValue}/${id}`,
    params,
  );
  return response.data;
};

export const deleteAgencyTimesheetValueByIdApi = async (
  id: string,
): Promise<{ success: boolean }> => {
  const response = await axios.delete(
    `${endPoints.agency.deleteTimesheetValue}/${id}`,
  );
  return response.data;
};

export const getAgencyAssignmentByIdApi = async (
  id: string,
  params: GetAgencyAssignmentByIdParams,
): Promise<GetAgencyAssignmentByIdResponse> => {
  const response = await axios.get(
    `${endPoints.agency.main}/assignments/${id}`,
    { params },
  );
  return response.data;
};

export const createAgencyApi = async (
  params: CreateAgencyParams,
): Promise<CreateAgencyResponse> => {
  const response = await axios.post(endPoints.agency.main, params);
  return response.data;
};

export const createAgencyV2Api = async (
  params: CreateAgencyPayload,
): Promise<CreateAgencyResponse> => {
  const response = await axios.post(endPoints.agency.createV2, params);
  return response.data;
};

export const updateAgencyByIdApi = async (
  id: string,
  params: UpdateAgencyByIdParams,
): Promise<UpdateAgencyByIdResponse> => {
  const response = await axios.put(`${endPoints.agency.main}/${id}`, params);
  return response.data;
};

export const createAgencyBranchByIdApi = async (
  id: string,
  params: CreateAgencyBranchParams,
): Promise<CreateAgencyBranchResponse> => {
  const response = await axios.post(
    `${endPoints.agency.main}/site/${id}`,
    params,
  );
  return response.data;
};

export const updateAgencyBranchByIdApi = async (
  id: string,
  params: UpdateAgencyBranchParams,
): Promise<UpdateAgencyBranchResponse> => {
  const response = await axios.put(
    `${endPoints.agency.main}/site/${id}`,
    params,
  );
  return response.data;
};

export const createAgencyContactByIdApi = async (
  id: string,
  params: CreateAgencyContactParams,
): Promise<CreateAgencyContactResponse> => {
  const response = await axios.post(
    `${endPoints.agency.main}/contact/${id}`,
    params,
  );
  return response.data;
};

export const updateAgencyContactByIdApi = async (
  id: string,
  params: UpdateAgencyContactParams,
): Promise<UpdateAgencyContactResponse> => {
  const response = await axios.put(
    `${endPoints.agency.main}/contact/${id}`,
    params,
  );
  return response.data;
};

export const deleteAgencyContactByIdApi = async (
  id: string,
): Promise<{ success: boolean }> => {
  const response = await axios.delete(
    `${endPoints.agency.main}/contact/${id}`,
  );
  return response.data;
};

export const deleteAgencySiteByIdApi = async (
  id: string,
): Promise<{ success: boolean }> => {
  const response = await axios.delete(
    `${endPoints.agency.main}/site/${id}`,
  );
  return response.data;
};

export const updateAgencyMarginByIdApi = async (
  id: string,
  params: UpdateAgencyMarginByIdParams,
): Promise<UpdateAgencyMarginByIdResponse> => {
  const response = await axios.post(
    `${endPoints.agency.main}/margin/${id}`,
    params,
  );
  return response.data;
};

export const updateAgencyBankByIdApi = async (
  id: string,
  params: UpdateAgencyBankByIdParams,
): Promise<UpdateAgencyBankByIdResponse> => {
  const response = await axios.post(
    `${endPoints.agency.main}/bank/${id}`,
    params,
  );
  return response.data;
};

export const getAgencyTimeSheetListApi = async (
  id: string,
  params: GetInvoiceListParams & { invoiceStatus: InvoiceStatus },
): Promise<GetInvoiceListParams> => {
  const response = await axios.get(
    `${endPoints.agency.main}/time-sheets/${id}`,
    { params },
  );
  return response.data;
};
